// The permanent-member relationships a family may self-add via the App (D8).
// Values MUST match the CRM MemberRole strings exactly — the App Backend
// forwards them verbatim to the CRM integration endpoint.
export const ADDABLE_MEMBER_RELATIONSHIPS: { value: string; label: string }[] = [
  { value: 'Mother', label: 'Mother' },
  { value: 'Father', label: 'Father' },
  { value: 'Step-Mother', label: 'Step-mother' },
  { value: 'Step-Father', label: 'Step-father' },
  { value: 'Grandparent', label: 'Grandparent' },
  { value: 'Guardian', label: 'Guardian / carer' },
  { value: 'Sibling', label: 'Sibling' },
  { value: 'Other', label: 'Other' },
];

// Display label for any member relationship value (handles the narrow
// legacy union AND the CRM role strings that flow through at runtime).
export function memberRelationshipLabel(value: string): string {
  const match = ADDABLE_MEMBER_RELATIONSHIPS.find((r) => r.value === value);
  return match ? match.label : value;
}
